import { render, staticRenderFns } from "./ItemListEntryLayout.vue?vue&type=template&id=491a5fb5&scoped=true"
import script from "./ItemListEntryLayout.vue?vue&type=script&lang=js"
export * from "./ItemListEntryLayout.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "491a5fb5",
  null
  
)

export default component.exports